/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
export class CertificationEntity extends Entity {
  award: string | null = null;
  candidateId: string | null = null;
  id: string = '';
  institution: string | null = null;
  stateExamScore: string | null = null;
  year: number | null = null;
  static override key = 'Certification';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'Certification' in input
    ) {
      const { Certification: wrapped, ...rest } = input as {
        Certification: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}